import { FC, useContext } from "react";

import { MemberEligibilityContext } from "@/App/context/MemberEligibilityContext";

import { useIsDiscountUser, useShowUnifiedCard } from "../../hooks";
import { DiscountCardFront } from "./DiscountCard";
import { NonDiscountCardFront } from "./NonDiscountCard";
import { UnifiedCardFront } from "./UnifiedCard";

export const MemberCardFront: FC = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);
  const { isDiscountUser } = useIsDiscountUser();
  const { showUnifiedCard } = useShowUnifiedCard();

  if (isDiscountUser) {
    return <DiscountCardFront memberEligibilityInfo={memberEligibility} />;
  } else if (showUnifiedCard) {
    return <UnifiedCardFront memberEligibilityInfo={memberEligibility} />;
  } else {
    return <NonDiscountCardFront memberEligibilityInfo={memberEligibility} />;
  }
};
